import React from 'react';
import Header from './Header';
import Footer from './Footer';
import LineworxClient from './lineworxClient';
import Jobs from './JobsPage/Jobs';
import Login from './Login/Login';
import GenericNotFound from './GenericNotFound';
import ResetPassword from './ResetPassword';
import Job from './OneJobPage/Job';
import Crew from './Crew/Crew';
import { Route, Redirect, Switch, useLocation} from 'react-router-dom'
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import LineworxProvider from './context/LineworxContext';
import User from './Login/User';
import ErrorBoundary from './ErrorBoundary';

//import AppTheme from './theme';

// CSS ROOTS
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';


function Routing() {
        return (
            // <Router history={window.history}>
          <div>
            <div className="non-footer">
              <Header ></Header>
      
                <div id="PageContainer">
                <TransitionGroup component={null}>
                    <CSSTransition key="test" in={true} classNames="slide-in" timeout={400}>
                  <Switch >
                    {/*  */}
                    <Route exact path="/" component={Landing} />
{/*                     
                    <Route path="/login" render={(props) => <Login {...props} authDialogState={AuthDialogState.Login} />} />
                    <Route path="/reset-password" render={(props) => <ResetPassword {...props} onLoginClicked={this.onLoginClicked} />} />
     */}
    
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/resetPassword" component={ResetPassword} />
                    
                        <PrivateRoute path="/jobs" component={Jobs} />
                        <PrivateRoute path="/job" component={Job} />
                        <PrivateRoute path="/user" component={User} />
                        <PrivateRoute path="/crew" component={Crew} />
                        <Route component={GenericNotFound} />
                    {/* <PrivateRoute path="/artist-assets/:id" component={ArtistAsset} />
    
                    <PrivateRoute path="/profile" component={Profile} />
                    <PrivateRoute path="/upload" component={UploadWizard} />
                    <PrivateRoute path="/product/:productId" component={ProductDetails} />
                    <PrivateRoute path='/:id' component={UploadWizard} /> */}
                  </Switch>
                  </CSSTransition>
                  </TransitionGroup>
                </div>
    
            </div>
      
            {/* <AuthDialog wrappedComponentRef={ref => this.authDialogRef = ref} /> */}
      
            <Footer></Footer>
      
          </div>
      
          //</Router>
        )
    }
//}


const Landing = () => {
    if (LineworxClient.isLoggedIn()) {
      return <Redirect to={"/jobs"} />;
    } else {
      return <Redirect to={"/login"} />;
    }
  }

//   LineworxClient.isLoggedIn() === true
//         ? <Component {...props} />
//         :


const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
        LineworxClient.isLoggedIn() === true
        ? <Component {...props} />
        : <Redirect to={{
            pathname: '/login',
            state: { from: props.location }
          }} />
    )} />
  )

//   const PrivateRoute = ({ component: Component, ...rest }) => (
//     <Route {...rest} render={(props) => {
        
//        <Redirect to={'/login'}/>
//         }} />
//   )



// const useStyles = makeStyles((theme) => {
//   root: {
//     // some CSS that accesses the theme
//   }
// });


  export default function App () {

    return (
      // <AppTheme>
        <LineworxProvider>
            <div className="App">
              {/* <ErrorBoundary> */}
                <Routing />
                {/* </ErrorBoundary> */}
            </div>
        </LineworxProvider>
      // </AppTheme>
    );
  }
